import React from "react";
import styles from "./dashboard.module.scss";
//import Carousel from "react-elastic-carousel";
import Product from "../../components/product/Product";
import Title from "../../components/title/Title";

const GroupDashboard = (props) => {

    const { data } = props;

    const showGroupDetail = (item) => {
        props.setGroup(item)
        props.setSubRegion({})
        props.history.push("/dashboard/groupdetail");
    }

    return (
        <div className={`${styles.grpContainerWidth}`}>
            <div className={`${styles.groupProductsContainer}`}>
                <div className={styles.productBoxGroup}>
                    <Title value="Group" count={null} />
                    <Product
                        product={data.group}
                        {...props}
                        type="group"
                        showDetail={() => showGroupDetail(data.group)} />
                </div>
            </div>
        </div>
    )

}
export default GroupDashboard;